import React from 'react';
import { format, parseISO } from 'date-fns';
import { toast } from 'react-hot-toast';
import './UserDashboard.css';
import './MyWorkoutsPage.css';

const mockCompletedSessions = [
  {
    sessionId: 'preview-1',
    workoutName: 'Upper Body Strength',
    startedAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    duration: 2580,
    exercisesCompleted: 8
  },
  {
    sessionId: 'preview-2',
    workoutName: 'HIIT Cardio Circuit',
    startedAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    duration: 1860,
    exercisesCompleted: 6
  },
  {
    sessionId: 'preview-3',
    workoutName: 'Leg Day — Compound Focus',
    startedAt: new Date(Date.now() - 9 * 24 * 60 * 60 * 1000).toISOString(),
    duration: 3120,
    exercisesCompleted: 10
  }
];

const MyWorkoutsPreview = () => {
  const requireSignIn = (action) => {
    toast.error(`Please sign in to ${action}`, {
      duration: 3000,
      icon: '🔒'
    });
  };

  return (
    <div className="my-workouts-preview-wrapper">
      <div className="preview-banner">
        <i className="fas fa-info-circle" aria-hidden />
        <span>Sign in to schedule workouts, track progress, and log real sessions</span>
      </div>

      <div className="my-workouts-page my-workouts-page--preview">
        <div className="my-workouts-header">
          <h1><i className="fas fa-calendar-check" aria-hidden /> My Workouts</h1>
          <p>Preview — sample completed workouts below. Scheduling and live tracking require an account.</p>
        </div>

        <div className="my-workouts-preview-schedule-placeholder">
          <h2><i className="fas fa-calendar-week" aria-hidden /> Weekly schedule</h2>
          <p className="my-workouts-preview-hint">
            Plan programs and workouts on your calendar, drag to reschedule, and start sessions from each day.
          </p>
          <div className="my-workouts-preview-locked-toolbar">
            <button
              type="button"
              className="week-nav-btn disabled-preview"
              disabled
              onClick={() => requireSignIn('change weeks')}
            >
              <i className="fas fa-chevron-left" />
            </button>
            <span className="week-label-preview">This week (preview)</span>
            <button
              type="button"
              className="week-nav-btn disabled-preview"
              disabled
              onClick={() => requireSignIn('change weeks')}
            >
              <i className="fas fa-chevron-right" />
            </button>
            <button
              type="button"
              className="today-btn disabled-preview"
              disabled
              onClick={() => requireSignIn('use your schedule')}
            >
              Today
            </button>
          </div>
          <div
            className="my-workouts-preview-schedule-overlay"
            onClick={() => requireSignIn('build your schedule')}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                requireSignIn('build your schedule');
              }
            }}
            role="button"
            tabIndex={0}
          >
            <i className="fas fa-lock" aria-hidden />
            <span>Sign in to schedule and track workouts</span>
          </div>
        </div>

        <div className="recent-history-section">
          <h2><i className="fas fa-history" aria-hidden /> Recent workouts</h2>
          <p className="my-workouts-preview-sample-label">Sample completed sessions (not your data)</p>
          <div className="recent-sessions-list">
            {mockCompletedSessions.map((session) => (
              <div
                key={session.sessionId}
                className="recent-session-card my-workouts-preview-session-card"
                onClick={() => requireSignIn('view session history and stats')}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    requireSignIn('view session history and stats');
                  }
                }}
                role="button"
                tabIndex={0}
              >
                <div className="session-icon">
                  <i className="fas fa-dumbbell" aria-hidden />
                </div>
                <div className="session-info">
                  <h4>{session.workoutName}</h4>
                  <span className="session-date">
                    {format(parseISO(session.startedAt), 'MMM d, yyyy')}
                  </span>
                </div>
                <div className="session-meta">
                  {session.duration != null && (
                    <span className="session-duration">
                      <i className="fas fa-clock" aria-hidden /> {Math.round(session.duration / 60)}m
                    </span>
                  )}
                  <span className="session-exercises">{session.exercisesCompleted} exercises</span>
                </div>
                <i className="fas fa-lock session-arrow-preview" aria-hidden />
              </div>
            ))}
          </div>
        </div>

        <div className="preview-cta">
          <h2>Ready to train on your terms?</h2>
          <p>Sign in to see your real history, resume in-progress workouts, and sync with coaches or your business.</p>
        </div>
      </div>
    </div>
  );
};

export default MyWorkoutsPreview;
